<template>
	<Disclosure :default-open="expanded">
		<DisclosureButton
			class="group flex w-full justify-between border-t-[1px] border-stone-400 py-4 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-stone-400 focus-visible:ring-opacity-75"
			:aria-labelledby="labelId"
		>
			<span :id="labelId" :aria-label="label" class="text-sm lg:text-base">{{ title }}</span>
			<span
				class="inline-block transform transition-transform duration-200 ease-in-out group-data-[headlessui-state=open]:rotate-45"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="19.359"
					height="19.359"
					viewBox="0 0 19.359 19.359"
				>
					<g data-name="Group 562" transform="translate(-761.067 -941.823) rotate(45)">
						<line
							data-name="Line 189"
							x2="12.628"
							y2="12.628"
							transform="translate(1211.5 121.5)"
							fill="none"
							stroke="#afafaf"
							stroke-width="1.5"
						/>
						<line
							data-name="Line 190"
							x1="12.628"
							y2="12.628"
							transform="translate(1211.5 121.5)"
							fill="none"
							stroke="#afafaf"
							stroke-width="1.5"
						/>
					</g>
				</svg>
			</span>
		</DisclosureButton>
		<DisclosurePanel class="pb-6 text-xs lg:text-sm">
			<slot></slot>
		</DisclosurePanel>
	</Disclosure>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue"
</script>

<script>
export default {
	name: "IntAccordionItem",
	props: {
		title: {
			type: String,
			required: true,
		},
		expanded: {
			type: Boolean,
			default: false,
		},
		labelId: { type: String },
		label: { type: String },
	},
}
</script>
